import { DialogPopupPayload, PopupType } from '@nx-frontend/shared/types';

export const needOwnerToPurchasePortalPopup = {
  title: 'The portal limit has been reached',
  content: PopupType.DIALOG,
  showCloseButton: true,
  closeButtonSize: 18,
  payload: {
    payloadType: PopupType.DIALOG,
    text: 'The portal limit has been reached. Please contact the owner for more details.',
    buttons: [
      {
        text: 'OK',
      },
    ],
  } as DialogPopupPayload,
};
